import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EditStudentComponent } from './edit-student.component';

import { UserDataComponent } from './user-data/user-data.component';
import { UserPasswordComponent } from './user-password/user-password.component';
import { UserBindComponent } from './user-bind/user-bind.component';
import { UserNewsComponent } from './user-news/user-news.component';
const routes: Routes = [
  {
    path: '', component: EditStudentComponent,
    children: [
      { path: '', redirectTo: 'set', pathMatch: 'full' },
      { path: 'data', component: UserDataComponent },
      { path: 'password', component: UserPasswordComponent },
      { path: 'bind', component: UserBindComponent },
      { path: 'news', component: UserNewsComponent }
    ],
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EditStudentRoutingModule { }



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/user-info/edit-student/edit-student-routing.module.ts